import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Image from 'next/image';
import filterIcon from '@/public/images/icons/filter.svg';
import { RefinementList, Menu, ToggleRefinement } from 'react-instantsearch';
import styles from './filterSkus.module.scss';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import CustomRefinementListDesktop from './algoliaCustom/CustomRefinementList';
import { CustomRangeInput } from './algoliaCustom/CustomRangeInput';
import 'instantsearch.css/themes/satellite.css';

const FilterSkus = () => {
  const { t: tCommon } = useTranslation('common');
  return (
    <Card className={styles.hideMobile}>
      <Card.Header className="border-0 bg-white px-5 pb-0 m-0">
        <div className="h5 border-bottom mt-3 pb-3">
          <Image
            src={filterIcon}
            width={24}
            height={24}
            alt="Filter"
            className="me-2"
          />
          {translationFallback('filter', tCommon('filter'), 'Filter')}
        </div>
      </Card.Header>
      <Card.Body className={`px-4 pt-0 ${styles.filterContainer}`}>
        <Accordion
          defaultActiveKey="0"
          flush
          className={styles.accordionCustomHeader}
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback('type', tCommon('type'), 'Type')}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <Menu
                attribute="category.name"
                classNames={{
                  label: 'font-size-14 fw-500',
                  count: styles.labelCount,
                }}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback('status', tCommon('status'), 'Status')}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <ToggleRefinement
                attribute="hasBid"
                label={translationFallback(
                  'has_bids',
                  tCommon('has_bids'),
                  'Has bids'
                )}
              />
              <ToggleRefinement
                attribute="hasAsk"
                label={translationFallback(
                  'has_asks',
                  tCommon('has_asks'),
                  'Has Asks'
                )}
              />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback('brand', tCommon('brand'), 'Brand')}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <CustomRefinementListDesktop
                attribute="brand.name"
                label="Brand"
              />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback(
                  'category',
                  tCommon('category'),
                  'Category'
                )}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <CustomRefinementListDesktop
                attribute="subCategory"
                label="subCategory"
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback('price', tCommon('price'), 'Price')}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <CustomRangeInput styles={styles} attribute="lowestAsk" />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback('country', tCommon('country'), 'Country')}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <RefinementList attribute="brand.countryOfOrigin" />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6">
            <Accordion.Header>
              <span className="font-size-18 fw-bold">
                {translationFallback('region', tCommon('region'), 'Region')}
              </span>
            </Accordion.Header>
            <Accordion.Body className="px-0">
              <RefinementList attribute="brand.region" />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Card.Body>
    </Card>
  );
};

export default FilterSkus;
